import React from "react";

const Card = ({ icon, title, value }) => {
  return (
    <div className="flex items-center rounded-md p-2 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-center bg-[#ecf6fe] p-2 rounded-md">
        <img src={icon} alt={title} />
        {/* {icon} */}
      </div>
      <div className="flex flex-col items-center justify-center w-full">
        <p className="text-xs text-gray-500 font-medium">
          {title.toUpperCase()}
        </p>
        <p className="text-gray-700 font-medium text-2xl">{value}</p>
      </div>
    </div>
  );
};

export default Card;
